import type { TextareaHTMLAttributes } from 'react'

import cx from 'classnames'

import styles from './input.module.css'

export function Textarea ({ placeholder, className, ...rest }: TextareaHTMLAttributes<HTMLTextAreaElement>): JSX.Element {
  return (
    <div className={styles.inputWrapper}>
      <label
        htmlFor=''
        className={styles.inputLabel}
      >
        {placeholder}
      </label>
      <textarea
        cols={3}
        className={cx(styles.input, className)}
        {...rest}
      />
    </div>
  )
}
